import React, { useState, useEffect } from "react";

import RecentOrders from "shared-anpost-components/components/recentOrders/RecentOrders";

const ShopRecentOrders = () => {
    const [loggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        window.loginOverride = window.loginOverride || {};
        window.loginOverride.callback = () => {
            setLoggedIn(true);
        };
    }, []);

    return loggedIn && <RecentOrders shopHomepageComponent />;
};

export default ShopRecentOrders;
